


/* Waves
============================================================*/
$(document).ready(function () {
	Waves.init();
	Waves.attach('.waves-effect');
});
/*========== Waves ==========*/







/* Sidebar Toggle
============================================================*/
$(document).on('click', '.nav_menu_btn', function (e) {
	$('.aside').toggleClass('active');
	$('.main').toggleClass('active');
});
/*========== Sidebar Toggle ==========*/


$('.spinner .btn:first-of-type').on('click', function() {
	$('.spinner input').val( parseInt($('.spinner input').val(), 10) + 1);
});
$('.spinner .btn:last-of-type').on('click', function() {
	$('.spinner input').val( parseInt($('.spinner input').val(), 10) - 1);
});

/* Date datepicker
============================================================*/
$(".day").datepicker({
	format: 'dd',
	maxViewMode: 0,
	language: 'ru'
});


//Calendar
$('.input-group.date').datepicker({
	language: 'ru'
});

//Adding date
var max_fields      = 10; //maximum input boxes allowed
var wrapper   		= $(".input_fields_wrap, .add-date"); //Fields wrapper
var add_button      = $(".add_field_button"); //Add button ID

var x = 1; //initlal text box count
$(add_button).click(function(e){ //on add input button click
	e.preventDefault();
	if(x < max_fields){ //max input box allowed
		x++; //text box increment
		$(wrapper).append('<div class="input-group date"><input type="text" class="form-control base_input" name="mytext[]" placeholder="Выберите дату" /><div class="input-group-addon"><a href="#" class="remove_field"><i class="mdi mdi-minus-circle"></i></a></div></div>'); //add input box
		$('.input-group.date').datepicker({
			language: 'ru'
		});
	}
});

$(wrapper).on("click",".remove_field", function(e){ //user click on remove text
	e.preventDefault(); $(this).closest('.date').remove(); x--;
});


//Datepicker
$('.datepicker').datepicker({
	language: 'ru'
});





